<template>
    <div>
        <div @click="isActive = true; isSent = false">
            <slot></slot>
        </div>
        <div class="modal" :class="{'is-active':isActive}">
            <div class="modal-background" @click="close(false)"></div>
            <transition name="fade" mode="out-in">
                <div class="modal-card" v-if="isActive">
                    <div v-if="isSent">
                        <header class="modal-card-head">
                            <button class="delete" aria-label="close" @click="close"></button>
                        </header>
                        <section class="modal-card-body">
                            <p clas="small">{{$t('message-with-link-was-sent')}}</p>
                        </section>
                        <footer class="modal-card-foot">
                            <button type="submit" class="button" @click="close">Ok, Dziekuję</button>
                        </footer>
                    </div>
                    <form class="form-card" @submit.prevent="handleSubmit" v-else>
                        <header class="modal-card-head">
                            <button class="delete" aria-label="close" @click="close"></button>
                        </header>
                        <section class="modal-card-body">
                            <p class="title has-text-centered">{{$t('want-download-file')}}</p>
                            <p clas="small">{{$t('fill-form')}}</p>
                            <div class="field">
                                <div class="control">
                                    <label class="label">{{$t('name-and-surname')}}*</label>
                                    <input class="input" type="text" name="name" v-model="name">
                                </div>
                            </div>
                            <div class="field">
                                <div class="control">
                                    <label class="label">E-mail*</label>
                                    <input class="input" type="text" name="email" v-model="email">
                                </div>
                            </div>
                            <div class="field">
                                <div class="control">
                                    <label class="label">{{$t('company')}}*</label>
                                    <input class="input" type="text" name="company" v-model="company">
                                </div>
                            </div>
                            <div class="control">
                                <label>*{{$t('field-required')}}</label>
                            </div>
                            <div class="field">
                                <div class="control">
                                    <label class="checkbox">
                                        <input type="checkbox" required />
                                        {{$t('agree')}} <a target="_blank" :href="privacyPolicyLink">{{$t('privacy-policy')}}</a>
                                    </label>
                                </div>
                            </div>
                            <div v-if="errors.length" class="errors">
                                <ul>
                                    <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
                                </ul>
                            </div>
                        </section>
                        <footer class="modal-card-foot">
                            <button type="submit" class="button">{{$t('send-email-with-link')}}</button>
                        </footer>
                    </form>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return {
            isActive: false,
            isSent: false,
            name: '',
            email: '',
            company: '',
            errors: []
        }
    },
    props: {
        fileId: {
            required: true
        },
        file: {
            type: String
        },
        postLang: {
            type: String
        }
    },
    computed: {
        privacyPolicyLink() {
            return this.$store.getters.getOption('privacy_policy_' + this.$i18n.locale);
        }
    },
    methods: {
        handleSubmit(){
            this.errors = [];
            if(!this.name){
                this.errors.push(this.$t('name-and-surname-required'));
            }
            if(!this.company){
                this.errors.push(this.$t('company-required'));
            }
            if(!this.isEmailValid(this.email)){
                this.errors.push(this.$t('email-required'));
            }
            if(this.name && this.company && this.isEmailValid(this.email)) {
                const sendData = {
                    'name': this.name,
                    'email': this.email,
                    'company': this.company,
                    'lang': this.postLang
                };
                axios.post( process.env.VUE_APP_API+'wp-json/ssw/v1/files/request/' + this.fileId, sendData).
                then(response => {
                    this.isSent = true
                }).catch((error) => {
                    console.log(error)
                })
            }
        },
        isEmailValid(email){
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        close(){
            this.isActive = false
        }
    }
}
</script>

<style lang="sass">
@import "@/styles/framework/variables.sass"
@import "@/styles/framework/extends.sass"
.modal
    .modal-card
        background-color: white
        border-radius: 8px
        .modal-card-head
            justify-content: flex-end
        .modal-card-body
            text-align: center
            p:not(.title)
                font-size: 1rem
                color: $blue1
            a
                color: $blue1
            .errors
                ul
                    list-style-type: none
                    li
                        color: red
                    li::before
                        content: ' '
        .form-card
            overflow-y: scroll
        .form-card::-webkit-scroll-track
            -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.8)
            background-color: #F5F5F5
            border-radius: 10px
        .form-card::-webkit-scrollbar
            width: 15px
            border-radious: 0 50% 50% 0
            background-color: #F5F5F5
            border-radius: 0 10px 10px 0
        .form-card::-webkit-scrollbar-thumb
            background-color: $blue1
            border-radius: 10px
        .modal-card-foot
            button, input
                margin: auto
​
</style>
